module.exports = class StripeTransformer {
  constructor(customer) {
    this.customer = customer
  }

  transform() {
    return {
      classification: "User",
      email: this.customer.email,
      identifier: this.customer.email,
      name: this.customer.name,
      createdAt: new Date(this.customer.created * 1000),
    }
  }
}
